// tslint:disable-next-line: max-line-length
export const SEQUENCE_INTEGER_FORMULA = 'STR_PAD_LEFT(VAR("---Sequence-Integer---"), FIELD("app/sequence:number-of-digits", VAR("Sequence tip")), "0")';
export const SEQUENCE_INTEGER_LABEL = 'Sequence';
